import { AppContext } from "../core/context";


export function pauseRender(ctx: AppContext) {
    ctx.render = false;
}

export function isReady(ctx: AppContext) {
    if (!ctx.scene.isReady()) return false;

    if (!ctx.light.isReady(true)) return false;

    for (let tex of ctx.scene.textures) {
        if (!tex.isReady()) return false;
    }

    for (let mesh of ctx.scene.meshes) {
        if (!mesh.isReady()) return false;
    }

    return true;
}

export async function resumeRender(ctx: AppContext) {

    let renderInterval;
    return new Promise(resolve => {
        renderInterval = setInterval(function () {
            if (isReady(ctx)) {
                clearInterval(renderInterval);
                ctx.render = true;
                resolve(true);
            }
        }, 250);
    });
}

export function enableDebug(ctx: AppContext) {
    var keysPressed = {};

    document.addEventListener("keydown", function (event) {
        keysPressed[event.key] = true;

        if (keysPressed["Alt"]) {
            ctx.scene.debugLayer.show({
                embedMode: true
            });
        }
    });
}

export function resetGUI(ctx: AppContext) {
    ctx.GUI.scaleTo(ctx.canvas.width, ctx.canvas.height);
    ctx.GUI.markAsDirty();
    ctx.GUI.invalidateRect(0, 0, ctx.canvas.width - 1, ctx.canvas.height - 1);
}

export function clearUI(ctx: AppContext) {
    //Remove UI controls 
    if (ctx.GUI) {
        ctx.GUI.rootContainer.clearControls();
    }
}

export function cleanupAssets(ctx: AppContext) {
 
    clearUI(ctx);

    //Remove all meshes in module
    if (ctx.scene) {

        let modulesNode = ctx.scene.getNodeById("modules") as BABYLON.TransformNode;
        if (modulesNode) {

            const childMeshes = modulesNode.getChildMeshes(false, x => x.metadata && x.metadata.meshtype !== "leg");
            const childNodes = modulesNode.getChildTransformNodes(false);

            childMeshes.forEach(function (mesh) {
                mesh.dispose(false, true);
                mesh = null;
            });

            childNodes.forEach(function (node) {
                node.dispose(false);
                node = null;
            });
        }
    }
}
